<div class="list-container mat-elevation-z2">
    <div class="loading-shade"
         *ngIf="isLoadingResults">
      <mat-spinner *ngIf="isLoadingResults"></mat-spinner>

    </div>
  
    <div class="table-container">
  
      <table mat-table [dataSource]="filteredAndPaged" class="table" matSort
             matSortActive="created" matSortDisableClear matSortDirection="desc"
             (matSortChange)="resetPaging()">

  

        <ng-container matColumnDef="displayName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Name</th>
          <td mat-cell *matCellDef="let row">{{row.displayName|| "(Unnamed)"}}</td>
        </ng-container>
        <ng-container matColumnDef="startDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Start Date</th>
            <td mat-cell *matCellDef="let row">{{row.availability.startDate | date}}</td>
        </ng-container>

        <ng-container matColumnDef="endDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>End Date</th>
            <td mat-cell *matCellDef="let row">{{row.availability.endDate | date}}</td>
        </ng-container>
  
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr [routerLink]="['/retailers', retailer.id, 'offers', row.id]" class="offer-table-row" mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  
    <mat-paginator [pageSize]="30"></mat-paginator>
  </div>